import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DeleteConfirmationDialogComponent } from "./views/agenda/delete-confirmation-dialog/delete-confirmation-dialog.component";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgScrollbarModule } from "ngx-scrollbar";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppComponent } from "./app.component";
import { LogoutComponent } from "./views/login/logout.component";
import { AgendaComponent } from "./views/agenda/agenda.component";
import { AgendaDayComponent } from "./views/agenda/agenda-day.component";
import { LoginComponent } from "./views/login/login.component";
import { SignaletiqueDetailComponent } from "./views/signaletique/signaletique-detail.component";
import { SignaletiqueGrilleComponent } from "./views/signaletique/signaletique-grille.component";

import { AuthGuardService } from "./services/authentication/auth-guard.service";
import { AuthService } from "./services/authentication/auth.service";
import { UtilisateurService } from "./services/utilisateur/utilisateur.service";
import { AlertService } from "./services/alert.service";
import { ConfigService } from "./services/config/config.service";
import { CodesService } from "./services/codes/codes.service";
import { PersonnelService } from "./services/personnel/personnel.service";
import { AgendaService } from "./services/agenda/agenda.service";
import { AjouterPrestaDialog } from "./views/agenda/ajouter-presta-dialog.component";
import { ModifPeriodeDialog } from "./views/agenda/modif-periode-dialog.component";

// import ngx-translate and the http loader
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpErrorInterceptor } from "./services/http-error.interceptor";

// import material Angualar
import { MatTooltipModule } from "@angular/material/tooltip";
import "hammerjs";

// Import containers
import { FullLayoutComponent, SimpleLayoutComponent } from "./containers";

const APP_CONTAINERS = [FullLayoutComponent, SimpleLayoutComponent];

// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  AlertComponent,
} from "./components";

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  AlertComponent,
];

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
} from "./directives";

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
];

// Import routing module
import { AppRoutingModule } from "./app.routing";

// Import 3rd party components
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
// import { ChartsModule } from 'ng2-charts/ng2-charts';

import { MaterialModule } from "./material.module";
// import { DevExtremeModule } from './dev-extreme.module';
import { JwtInterceptor } from "./services/jwt.interceptor";
import { EmailComponent } from "./views/communication/email/email.component";

import { TextareaAutosizeModule } from "ngx-textarea-autosize";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ToastrModule } from "ngx-toastr";
import { AjouterMaladieDialogComponent } from "./views/agenda/ajouter-maladie-dialog/ajouter-maladie-dialog.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import {
  DxDataGridModule,
  DxBulletModule,
  DxTemplateModule,
  DxTreeListModule,
} from "devextreme-angular";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  imports: [
    BrowserModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    FontAwesomeModule,
    BrowserAnimationsModule,
    MaterialModule,
    DxDataGridModule,
    DxBulletModule,
    DxTreeListModule,
    DxTemplateModule,
    NgScrollbarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TextareaAutosizeModule,
    AngularEditorModule,
    ToastrModule.forRoot(),
    MatTooltipModule,
    MatDialogModule,
    MatSidenavModule,
    MatListModule

  ],

  declarations: [
    AppComponent,
    LogoutComponent,
    AjouterPrestaDialog,
    ModifPeriodeDialog,
    AgendaComponent,
    AgendaDayComponent,
    LoginComponent,
    SignaletiqueDetailComponent,
    SignaletiqueGrilleComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
    EmailComponent,
    AjouterMaladieDialogComponent,
    DeleteConfirmationDialogComponent
  ],

  exports: [
    AjouterMaladieDialogComponent,
    DeleteConfirmationDialogComponent,
    // DxDataGridModule,
    // DxBulletModule,
    // DxTemplateModule
    TranslateModule,
  ],
  providers: [
    AuthService,
    AlertService,
    AuthGuardService,
    HttpClientModule,
    UtilisateurService,
    ConfigService,
    CodesService,
    PersonnelService,
    AgendaService,

    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

platformBrowserDynamic().bootstrapModule(AppModule);

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
